(function($, undefined) {

	/**
	 * Extension pro ikonky u prodejny hover/touch
	 */
	$.nette.ext('storeProperties', {
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));
		}
	}, {
		selector: '.store-properties',
			init: function($el) {
				setTimeout(() => {
					var $els = $el.find(this.selector);
					var $w = $(window);

					if($('html').hasClass('touch')) {
						$els.find('li').on('click touchstart', function(e) {
							var $li = $(this);
							if(!$li.hasClass('touchHover')) {
								$li.addClass('touchHover').siblings().removeClass('touchHover');
							} else {
								$li.removeClass('touchHover');
							}
						});
					} else {
						$els.find('li').hover(
							function() {
								var $ico = $(this),
									$box = $ico.find('.text'),
									w = $w.width(),
									r = w - $ico.offset().left - $ico.outerWidth(),
									boxDim = ($box.outerWidth()/2 - $ico.outerWidth()/2);

								if( $ico.offset().left < boxDim ) {
									$ico.addClass('hover icoLeft');
								} else if( r < boxDim ) {
									$ico.addClass('hover icoRight');
								} else {
									$ico.addClass('hover')
								}
							}, function() {
								var $ico = $(this);
								$ico.removeClass('hover icoLeft icoRight');
							}
						);
					}
				}, 0)
			}
	});

})(jQuery);
